import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { NgbModal } from '@otas/modal/modal';
import { AppConstants } from '../../app.constants';
import { TransactionModalComponent } from './transaction-modal.component';
@Injectable()
export class TransactionModalService {


  constructor(private http: HttpClient, private modalService: NgbModal) { }
  public opentransactionModal(content, _mode, amount) {
    const modalRef = this.modalService.open(content, AppConstants.mediumModalOptions);
    TransactionModalComponent.mode = _mode;
    TransactionModalComponent.amount  = amount;
    return modalRef;
  }

}


